export default __webpack_public_path__ + "static/media/T_wdt_c_cap_1.a07fc9e8.mp3";